import { useState, useRef, useEffect } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const ListingLenderDisclaimer = (props) => {
    const lenderRef = useRef(null);
    const [showToolTip, setShowToolTip] = useState(false);

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick, { capture: true });
        return () => {
            document.removeEventListener('click', handleOutsideClick, { capture: true });
        };
    }, []);

    const handleOutsideClick = (e) => {
        if ((lenderRef.current && !lenderRef.current.contains(e.target))) {
            setShowToolTip(false);
        }
    };

    const handleClick = (e) => {
        e.preventDefault();
        setShowToolTip(showToolTip => !showToolTip)
    };

    return (
        <span className='lender-info' ref={lenderRef}>
            <LazyLoadImage src={props.disclaimerIcon} onClick={handleClick} alt='' />
            {showToolTip &&
                <div className='lender-tooltip'>
                    <span dangerouslySetInnerHTML={{ __html: props.disclaimerText }} />
                </div>}
        </span>
    );
};

export default ListingLenderDisclaimer;